import { Host, h } from "@stencil/core";
export class DnnChevron {
    constructor() {
        /** Expand text for screen readers */
        this.expandText = "expand";
        /** Collapse text for screen readers */
        this.collapseText = "collapse";
        /** Is the chevron expanded */
        this.expanded = false;
    }
    handleExpandedChanged(newValue) {
        this.changed.emit(newValue);
    }
    render() {
        return (h(Host, { key: 'c001180e714b5e803f196d4832ac9d7f77afe1dc', tabIndex: this.focused ? -1 : 0, onFocus: () => this.button.focus(), onBlur: () => this.button.blur() }, h("button", { key: '9fabb0018d815619edf0c38d6c41651a900e8115', ref: el => this.button = el, "aria-label": this.expanded ? this.collapseText : this.expandText, onClick: () => this.expanded = !this.expanded, onFocus: () => this.focused = true, onBlur: () => this.focused = false }, h("svg", { key: '8258366e1e45ded06aa6127ebe2cfb8ef66d509b', xmlns: "http://www.w3.org/2000/svg", height: "24px", viewBox: "0 0 24 24", width: "24px", fill: "#000000" }, h("path", { key: '9360e6ed6aa20d3b7aaa1d6162948319231d255e', d: "M0 0h24v24H0z", fill: "none" }), h("path", { key: 'c116570891918f909e50bc14e8a26fe00913c8be', d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" })))));
    }
    static get is() { return "dnn-chevron"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["dnn-chevron.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["dnn-chevron.css"]
        };
    }
    static get properties() {
        return {
            "expandText": {
                "type": "string",
                "attribute": "expand-text",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Expand text for screen readers"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "\"expand\""
            },
            "collapseText": {
                "type": "string",
                "attribute": "collapse-text",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Collapse text for screen readers"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "\"collapse\""
            },
            "expanded": {
                "type": "boolean",
                "attribute": "expanded",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Is the chevron expanded"
                },
                "getter": false,
                "setter": false,
                "reflect": true,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "focused": {}
        };
    }
    static get events() {
        return [{
                "method": "changed",
                "name": "changed",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Fires up when the expanded status changes"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get watchers() {
        return [{
                "propName": "expanded",
                "methodName": "handleExpandedChanged"
            }];
    }
}
//# sourceMappingURL=dnn-chevron.js.map
